import type { Location } from 'react-router-dom';
import { isBffHardeningOn } from '../api/harness/browserHarnessFlag';

const withoutCapability = (value: string, prefix: '?' | '#'): string => {
  const params = new URLSearchParams(value.replace(/^[?#]/, ''));
  if (!params.has('cap')) return value;
  params.delete('cap');
  const remaining = params.toString();
  return remaining ? `${prefix}${remaining}` : '';
};

export const withoutCapabilityQuery = (search: string): string =>
  withoutCapability(search, '?');

export const withoutCapabilityFragment = (hash: string): string =>
  withoutCapability(hash, '#');

export const getReturnPath = (location: Location): string => {
  if (!isBffHardeningOn()) {
    return `${location.pathname}${location.search}${location.hash}`;
  }
  return `${location.pathname}${withoutCapabilityQuery(
    location.search,
  )}${withoutCapabilityFragment(location.hash)}`;
};

// Block open-redirect attempts and reject anything that isn't a same-origin
// app path. A return path must start with a single `/`, never `//` or `/\`,
// which the browser would resolve as a protocol-relative or scheme-tricked URL.
export const safeReturnPath = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;
  if (!value.startsWith('/')) return null;
  if (value.startsWith('//') || value.startsWith('/\\')) return null;
  return value;
};
